import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useT } from '~app/core/BundleProvider';
import ConfirmationDialog from '~app/features/app/components/ConfirmationDialog';
import { actions as SaveLoadActions } from '~app/features/saveLoad';

function FileExists({ onCancel }) {
  const t = useT();
  const dispatch = useDispatch();
  const existingFile = useSelector(state => state.saveLoad.fileExistsPrompt);

  const handleOk = useCallback(() => {
    dispatch(SaveLoadActions.showFileExistsPrompt(null));
    dispatch(
      SaveLoadActions.saveToDrive({ file: existingFile, overwrite: true }),
    );
  }, [dispatch, existingFile]);

  const handleCancel = useCallback(() => {
    dispatch(SaveLoadActions.showFileExistsPrompt(null));
    if (onCancel) onCancel();
  }, [dispatch, onCancel]);

  return (
    <ConfirmationDialog
      title={t('file-exists-title')}
      text={t('file-exists-warning', { name: existingFile.name })}
      okLabel={t('overwrite-button')}
      cancelLabel={t('cancel-button')}
      onOk={handleOk}
      onCancel={handleCancel}
    />
  );
}

export default FileExists;
